import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGroupUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchMenuGroupUpdate = createAsyncThunk(
    'menuGroupUpdate/fetchMenuGroupUpdate',
    async ({ id, filesToKeep, file, title, description, content }) => {
        const response = await MenuGroupUpdateService(id, file, title, description, content, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const menuGroupUpdateSlice = createSlice({
    name: 'menuGroupUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroupUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGroupUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGroupUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGroupUpdateSlice.reducer;
